import React from 'react';

/**
 * Tab bar inside a detail drawer. Events and Sessions each had their own copy
 * that differed only in whether it could render a count badge; this is the one
 * both use so the drawers read the same.
 *
 * Tabs: `{ id, label, badge? }`. A badge of 0 or null is not rendered.
 */
export default function DetailTabs({ tabs = [], value, onChange }) {
  if (!tabs.length) return null;

  return (
    <div className="flex items-center gap-1 border-b border-[color:var(--border-default)] px-2" role="tablist">
      {tabs.map((tab) => {
        const isActive = value === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            // Underline rather than a filled pill: the drawer already uses
            // filled pills for the top-level grain switcher, and reusing that
            // treatment here made the two read as the same level of navigation.
            className={`-mb-px inline-flex items-center gap-1.5 border-b-2 px-2.5 py-2 text-[12px] font-medium transition-colors ${
              isActive
                ? 'border-[color:var(--trodo-primary)] text-[color:var(--text-primary)]'
                : 'border-transparent text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)]'
            }`}
          >
            {tab.label}
            {tab.badge ? (
              <span className="rounded-full bg-[color:var(--surface-sunken)] px-1.5 text-[10px] font-semibold tabular-nums text-[color:var(--text-primary)]">
                {tab.badge}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
